var _path, _path2, _path3, _path4, _path5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.482 10.7439L19.7406 5.42386C19.2659 3.97443 17.9815 3 16.5447 3H7.45531C6.01854 3 4.73408 3.97443 4.26023 5.42295L2.51885 10.743C1.58892 11.3971 1 12.5271 1 13.7703V20.1905C1 21.1902 1.75731 22 2.69231 22C3.62731 22 4.38462 21.1902 4.38462 20.1905V19.0496C4.38462 19.0496 8.85315 19.2857 12 19.2857C15.1468 19.2857 19.6154 19.0496 19.6154 19.0496V20.1905C19.6154 21.1902 20.3727 22 21.3077 22C22.2427 22 23 21.1902 23 20.1905V13.7703C23 12.5271 22.4102 11.3971 21.482 10.7439Z",
    fill: "url(#paint0_linear_25516_37463)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.85799 6.21148L4.88829 9.17367C4.73599 9.63962 5.09899 10.1092 5.55506 10.0305C7.21437 9.74367 9.34752 9.52381 12.0002 9.52381C14.6529 9.52381 16.7861 9.74367 18.4454 10.0305C18.9014 10.1092 19.2644 9.63962 19.1121 9.17367L18.1424 6.21148C17.9047 5.48586 17.2641 5 16.5449 5H7.45552C6.73629 5 6.09576 5.48586 5.85799 6.21148Z",
    fill: "#E6E5FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 16H15C15.552 16 16 15.328 16 14.5C16 13.672 15.552 13 15 13H9C8.448 13 8 13.672 8 14.5C8 15.328 8.448 16 9 16Z",
    fill: "#B1B0F5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 14.3571C3.5 15.1063 4.06862 15.7143 4.76923 15.7143C5.46985 15.7143 6.03846 15.1063 6.03846 14.3571C6.03846 13.608 5.46985 13 4.76923 13C4.06862 13 3.5 13.608 3.5 14.3571Z",
    fill: "#E6E5FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18 14.3571C18 15.1063 18.5686 15.7143 19.2692 15.7143C19.9698 15.7143 20.5385 15.1063 20.5385 14.3571C20.5385 13.608 19.9698 13 19.2692 13C18.5686 13 18 13.608 18 14.3571Z",
    fill: "#E6E5FF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_25516_37463",
    x1: 8.41887,
    y1: 25.5092,
    x2: 1,
    y2: 21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E8CEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.604167,
    stopColor: "#8E8CEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.604267,
    stopColor: "#B1B0F5"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar);
export default __webpack_public_path__ + "static/media/car.2d4b65e9565b00bc1cd5a754b20c1788.svg";
export { ForwardRef as ReactComponent };